import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@mui/material/Button";
import axios from "../axios";
import { toast } from "react-toastify";
import UserListItem from "../co-components/UserListItem";
import Spinner from "react-bootstrap/Spinner";
import UserSelectedItem from "../co-components/UserSelectedItem";
import "../../CSS/userListItem.css";

const GroupModal = (props) => {
  // console.log("props", props);
  // const [userInfo, setUserInfo] = useState(props.userInfo);
  const [groupChatName, setGroupChatName] = useState();
  const [selectedUsers, setSelectedUsers] = useState([]);
  // const [search, setSearch] = useState();
  const [searchResult, setSearchResult] = useState([]);
  const [chats, setChats] = useState(props.chats);
  const [loading, setLoading] = useState();

  const [windowInnerwidth, setWindowInnerWidth] = useState(0);
  useEffect(() => {
    function handleResize() {
      // console.log("window.innerWidth", window.innerWidth);
      setWindowInnerWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setWindowInnerWidth]);

  const searchUser = async (value) => {
    if (!value) {
      // toast.error("Please enter something to search user", {
      //   // position: "bottom-center",
      //   toastId: 18,
      // });
      return;
    }
    try {
      setLoading(true);
      const { token } = props.userInfo;
      await axios
        .get(`/user?search=${value}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setSearchResult(res.data);
          // console.log("resss", res.data);
          // if (res.data.length < 1) { }
        });
      setLoading(false);
      // setSearch("");
    } catch (error) {
      // toast.error("Error Occured", {
      //   toastId: 16
      // });
      console.log("Error Occured", error);
    }
  };
  const groupHandler = async (addThisUser) => {
    // console.log("clickeduser", addThisUser);
    // if (selectedUsers.includes(addThisUser)) {
    if (selectedUsers.find((u) => u._id === addThisUser._id)) {
      toast.error("This User already added", {
        // position: "bottom-center",
        toastId: 19,
      });
      return;
    }
    setSelectedUsers([...selectedUsers, addThisUser]);
  };
  const selectedUserDelete = async (notAddThisUser) => {
    // console.log("notAddThisUser", notAddThisUser);
    setSelectedUsers(
      selectedUsers.filter((del) => del._id !== notAddThisUser._id)
    );
  };
  const submit = async () => {
    if (!groupChatName || !selectedUsers) {
      toast.error("Please fill in all fields", {
        // position: "bottom-center",
        toastId: 20,
      });
      return;
    }
    try {
      // setLoading(true);
      const { token } = props.userInfo;
      const body = {
        name: groupChatName,
        users: JSON.stringify(selectedUsers.map((u) => u._id)),
      };
      // console.log("body", body);

      await axios
        .post("/chat/group/create", body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setChats([res.data, ...chats]);
          props.selectedChatHandler(res.data);
          // console.log("resss", res.data);
          props.setGroupModal(false);
        });
      toast.success("New group created successfully", {
        // position: "bottom-center",
        toastId: 20,
      });
      // setLoading(false);
    } catch (error) {
      // toast.error("Error Occured", {
      //   toastId: 16
      // });
      console.log("Error Occured while creating new group", error);
    }
  };

  return (
    <div>
      <Modal
        show={props.groupModal}
        // onHide={groupModalClose}
        onHide={() => props.setGroupModal(false)}
        centered
        // size="sm"
      >
        <Modal.Header
          closeButton
          className="modal-header border-0"
          // style={{ padding: "20px 20px 0px 0px" }}
          // style={{
          //   // fontSize: "25px",
          //   fontSize: windowInnerwidth>500? "25px" : "21px",
          //   textAlign: "center",
          //   fontFamily: "Work sans",
          //   fontWeight: "700",
          // }}
        >
          Create Group Chat
        </Modal.Header>
        <Modal.Body
          style={{
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
            padding: "10px 20px",
          }}
        >
          <div>
            <input
              placeholder="Group Name"
              className="form-control"
              // style={{ width: "400px", marginBottom: "15px" }}
              style={{
                width:
                  windowInnerwidth > 450
                    ? "400px"
                    : windowInnerwidth > 380
                    ? "350px"
                    : "280px",
                marginBottom: "15px",
              }}
              onChange={(e) => setGroupChatName(e.target.value)}
              maxlength="15"
            />
            <input
              style={{
                width:
                  windowInnerwidth > 450
                    ? "400px"
                    : windowInnerwidth > 380
                    ? "350px"
                    : "280px",
              }}
              placeholder="Add users e.g:  Nadeem Mansha, Nadeem Dev"
              className="form-control"
              onChange={(e) => searchUser(e.target.value)}
              maxlength="15"
            />
            {/* -----------Selected Users---------- */}
            {/* {selectedUsers.map((x) => {
              return (
                <UserSelectedItem
                  key={x._id}
                  user={x}
                  selectedUserDelete={() => selectedUserDelete(x)}
                />
              );
            })} */}
            <div style={{ marginTop: "3px", display: "flex" }}>
              {selectedUsers &&
                selectedUsers.map((user) => {
                  return (
                    <UserSelectedItem
                      key={user._id}
                      user={user}
                      selectedUserDelete={() => selectedUserDelete(user)}
                    />
                  );
                })}
            </div>
            {/* -------------Users List----------- */}
            {loading ? (
              <div style={{ minHeight: "50vh" }}>
                <Spinner
                  animation="border"
                  variant="secondary"
                  style={{ marginTop: "15px" }}
                />
              </div>
            ) : (
              <div style={{ minHeight: "50vh" }}>
                {searchResult?.slice(0, 4).map((user) => {
                  return (
                    <div
                      // style={{ marginTop: "15px" }}
                      style={{ marginTop: "15px" }}
                      onClick={() => groupHandler(user)}
                    >
                      <UserListItem
                        key={user._id}
                        user={user}
                        groupHandler={() => groupHandler(user)}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-header border-0">
          <Button variant="contained" onClick={submit}>
            Create Group
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <ToastContainer
        position="top-center"
        // position= {windowInnerwidth>500? "bottom-center" : "top-center"}
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      /> */}
    </div>
  );
};

export default GroupModal;
